<!-- legend / labels / open window: on the card title line when hosted by a dashboard card (no row of its own) -->
<ng-template #headerActions>
  <div class="buttonActions">
    @if (chart) {
      <button
        class="p-menu-bar-button"
        pButton
        showDelay="250"
        tooltipPosition="top"
        type="button"
        icon="{{ lastLegendDisplayState ? 'far fa-eye' : 'far fa-eye-slash' }}"
        [life]="3000"
        pTooltip="{{ 'chartWidgetUi.showLegend' | translate }}"
        (click)="changeLegendView()"></button>
      @if (hasCategoryAxis) {
        <button
          class="p-menu-bar-button"
          pButton
          showDelay="250"
          tooltipPosition="top"
          type="button"
          icon="fas fa-tags"
          [class.chart-axis-labels-off]="!axisLabelsShown"
          [attr.aria-pressed]="axisLabelsShown"
          [life]="3000"
          pTooltip="{{ (axisLabelsShown ? 'chartWidgetUi.hideAxisLabels' : 'chartWidgetUi.showAxisLabels') | translate }}"
          [attr.aria-label]="'chartWidgetUi.showAxisLabels' | translate"
          (click)="toggleAxisLabels()"></button>
      }
    }
    @if (this.widget.windowId) {
      <button
        class="p-menu-bar-button"
        icon="icon-search-bolder"
        pButton
        showDelay="250"
        tooltipPosition="top"
        type="button"
        [life]="3000"
        pTooltip="{{ 'widgetUi.openWindow' | translate }}"
        (click)="openTab($event)"></button>
    }
  </div>
</ng-template>
@if (!headerActionsInFrame) {
  <ng-container [ngTemplateOutlet]="headerActions" />
}

@if (dataToDisplay) {
  <p-chart #chart [data]="dataToDisplay" [height]="'100%'" [options]="options" [plugins]="plugins" [type]="chartType" />
} @else if (isLoading) {
  <div class="ghost-elt widget-ghost">
    <div class="ghost-rect widget-ghost-rect"></div>
  </div>
} @else if (noAccess) {
  <iu-widget-state class="no-data" state="noAccess" />
} @else if (loadError) {
  <iu-widget-state class="no-data" state="error" (retry)="retryLoad()" />
} @else {
  <iu-widget-state class="no-data" state="noData" />
}
